import { GeographicalDistributionInventors } from "./geographical-inventors";
export default GeographicalDistributionInventors;
